import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
export default {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Layout: lazy(() => import('./components/Layout.tsx')),
  CustomAudiences: lazyNamed(() => import('./containers/CustomAudiences/index.tsx'), 'CustomAudiences'),
  CustomAudiencesConfig: lazy(() => import('./containers/CustomAudiencesConfig/index.tsx')),
  CustomAudiencesConfigHistory: lazyNamed(
    () => import('./containers/CustomAudiencesConfigHistory/index.tsx'),
    'CustomAudiencesConfigHistory',
  ),
  IABAudiences: lazyNamed(() => import('./containers/IABAudiences/index.tsx'), 'IABAudiences'),
};
